import React from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import Layout from '../../layout/Layout';
import PricingPageWrapper from '../../components/pricing/_PricingPageWrapper';
import { PricingPageServersideProps } from '../../types/components/pricing/PricingPage';
import { seo, seoPricing } from '../../staticData/Seo';
import { fetchPricingServersideProps } from '../../helpers/pages/pricing/pricing';

const Pricing: React.FC<PricingPageServersideProps> = ({
  pageContent,
}) => {
  const router = useRouter();
  const dynamicSeo = seoPricing.find((seo) => seo.path === router.asPath);

  const headContent = {
    title: `ActionVFX Subscription Pricing`,
    keywords: ['actionvfx subscription', 'actionvfx pricing', 'vfx asset subscription', 'vfx asset pricing', '2d vfx asset'].concat(seo.keywords),
    description: dynamicSeo?.description || seo.description,
    og: seo.og
  };
  return (
    <Layout head={headContent}>
      <PricingPageWrapper
        pageContent={pageContent}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const fetchProps = await fetchPricingServersideProps();
  return fetchProps;
};

export default Pricing;
